import { FormFieldConfig } from './form-field-config.model';
import { generateShortUuid } from '../../../../../../../ag-common-svc/projects/ag-common-svc/src/shared/utils/generate-item-uuid';

export enum FormItemGroupKeys {
  id = 'id',
  order = 'order',
  colSpan = 'colSpan',
  colCount = 'colCount',
  items = 'items',
}

export class FormItemGroup {
  [FormItemGroupKeys.id]: string;
  [FormItemGroupKeys.order]: number;
  [FormItemGroupKeys.colSpan]: number;
  [FormItemGroupKeys.colCount]: number;
  [FormItemGroupKeys.items]: FormFieldConfig[];

  constructor() {
    this.id = generateShortUuid();
  }
}
